<template>
  <div class="p-3 pl-4">
    <div class="vertical-line" v-for="(item, index) in logs" :key="index">
      <div class="circle">
        <div class="dot"></div>
      </div>
      <div class="pl-3 content-log">
        <strong>{{ item[namekey] }}</strong>
        <div class="d-flex align-items-center mb-1 text-blue-400">
          <i class="fa fa-calendar-alt mr-2"></i>
          <p class="text-sm mb-0">{{ formatDateOrValue(item[datekey]) }}</p>
        </div>
        <small>{{ item[descriptionkey] }}</small>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    logs: {
      type: Array,
      default: () => [],
    },
    namekey: {
      type: String,
      default: 'name',
    },
    datekey: {
      type: String,
      default: 'date',
    },
    descriptionkey: {
      type: String,
      default: 'description',
    },
  },
  methods: {
    formatDateOrValue(value) {
      // Check if value is empty/null
      if (!value) return '-'

      // Try to parse as date
      const momentDate = moment(value)

      // Check if it's a valid date
      if (momentDate.isValid()) {
        return momentDate.format('DD MMMM YYYY HH:mm')
      } else {
        // Return the original value if it's not a valid date
        return value
      }
    },
  },
}
</script>
<style scoped>
.vertical-line {
  border-left: 2.4px solid #e5e7eb;
  min-height: 100px;
  position: relative;
}
.circle {
  width: max-content;
  border: 1.5px solid #1f48aa;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  padding: 4px;
  position: absolute;
  left: -10px;
  top: -6px;
}
.dot {
  width: 8px;
  height: 8px;
  background: #1f48aa;
  border-radius: 50%;
}
.text-blue-400 {
  color: #334697;
}
</style>
